import { useState, useEffect } from 'react';


export const useProducts = (initialProductsData, setSelectedFilters) => {
	const [currentPage, setCurrentPage] = useState(1);
	const [pageCount, setPageCount] = useState(0);
	const [currentProducts, setCurrentProducts] = useState([]);

	useEffect(() => {
		if (initialProductsData) {
			setCurrentPage(initialProductsData.current_page);
			setPageCount(initialProductsData.last_page);
			setCurrentProducts(initialProductsData.data);
		}
	}, [initialProductsData]);

	const handlePageChange = (page) => {
		if (page !== currentPage) {
			setCurrentPage(page); // Update current page state
			setSelectedFilters(prevFilters => ({
				...prevFilters,
				page // Update filters with the new page
			}));
		}
	};

	return {
		currentProducts,
		currentPage,
		pageCount,
		handlePageChange,
        setCurrentPage,
	};
};
